import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Image } from "semantic-ui-react";
import { useAuth0 } from "@auth0/auth0-react";
import { logoutUser } from "src/services/logout";
import { setGoogleAnalyticsEvent } from "src/common";
import { useLightMode } from "src/common/hooks/lightMode";
import { USE_COOKIE_AUTH } from "src/common/Auth/auth0-variables";
import { useTranslate, T } from "@tolgee/react";

function Logout({ user }) {
  const { logout, user: authUser } = useAuth0();
  const { lightMode } = useLightMode();
  const { t } = useTranslate();
  useEffect(() => {
    if (USE_COOKIE_AUTH) {
      setGoogleAnalyticsEvent({
        action: "portal_dashboard_logout",
      });
      logoutUser({ user, authUser, logout });
      return;
    }
    if (authUser) {
      setGoogleAnalyticsEvent({
        action: "portal_dashboard_logout",
      });
      logoutUser({
        user,
        authUser,
        logout,
      });
    }
  }, [logout, authUser, user]);

  return (
    <div
      className={`simple-message-container${lightMode ? " light-mode" : ""}`}
    >
      <div className="message-container">
        <Image
          src="/images/ctm-logo-landscape.png"
          title="Corporate Travel Management"
          alt="CTM Logo"
        />
        <p>
          {t({
            key: "pages.logoutPage.successfullyLoggedOut",
            defaultValue: "You have been successfully logged out.",
          })}
        </p>
        <p>
          <T
            keyName="pages.logoutPage.logBackIn"
            defaultValue="<link>Click Here</link> to log back in."
            params={{
              link: <NavLink to="/login" />,
            }}
          />
        </p>
      </div>
    </div>
  );
}

export default Logout;
